import { accessRole } from "../../../../../helpers/access_role";
import { config } from "../../../../../helpers/config_global";
import React, { useState, Component, Fragment } from "react";
import { Redirect } from "react-router-dom";

import { Tooltip } from "reactstrap";

import MKIDatatable from "../../../../../modules/mki-datatable/lib";
import { ConfirmAlert } from "../../../../../helpers/ui/alert";

import { cancelToken } from "../../../../../services/adapters/kepegawaian/organizationhistoriService";

import apiResponse from "../../../../../services/apiResponse";
import IndexBloc from "../Blocs/IndexBloc";

const reformatDate = (date) => {
  const months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];
  const d = new Date(date);
  let dt = d.getDate();
  if (dt < 10) dt = "0" + dt;

  if (date) {
    return dt + " " + months[d.getMonth()] + " " + d.getFullYear();
  }

  return "-";
};

class TableComponent extends Component {
  indexBloc = new IndexBloc();

  source;
  historyTable = "EmployeeTransferTableActive";
  defaultOrder = "employee_transfer_id";
  defaultSize = 10;
  defaultSort = "desc";
  configDatatable = {
    ...config("datatable"),
    sort: {
      column: this.defaultOrder,
      order: this.defaultSort,
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      tooltip: false,
      detailUuid: null,
      updateUuid: null,
      updateUuid: null,
      inactiveUuid: null,
      defaultSize: 10,
      rows: [],
      totalRow: 0,
      loadingTable: true,
      filter: sessionStorage.getItem(this.historyTable)
        ? JSON.parse(sessionStorage.getItem(this.historyTable))
        : {
            filter_value: "",
            page_number: 1,
            page_size: this.defaultSize,
            sort_order: {
              column: this.defaultOrder,
              order: this.defaultSort,
            },
          },
    };
  }

  toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

  loadData = async () => {
    /* history Datatable */
    sessionStorage.setItem(
      this.historyTable,
      JSON.stringify(this.state.filter)
    );

    /* kirim ke server */
    let offset =
      (this.state.filter.page_number - 1) * this.state.filter.page_size;
    if (this.state.defaultSize !== this.state.filter.page_size) {
      this.setState({
        defaultSize: this.state.filter.page_size,
      });
      offset = 0;
      this.configDatatable.page_number = 1;
    }
    const query = {
      search: this.state.filter.filter_value,
      limit: this.state.filter.page_size,
      offset: offset,
      order: this.state.filter.sort_order.column,
      sort: this.state.filter.sort_order.order,
      status: 1,
    };
    await this.indexBloc.fetchList(query, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadData();
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.inactiveData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  inactiveData = async () => {
    console.log(this.state.inactiveUuid);
    await this.indexBloc.fetchInactive({ uuid: this.state.inactiveUuid });
  };

  componentDidMount() {
    console.log(this.props);
    this.setTokenAPI();

    this.indexBloc.listChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingTable: false,
          });
          break;
        case apiResponse.LOADING:
          this.setState({
            loadingTable: true,
          });
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            totalRow: response.total,
            rows: response.result,
            loadingTable: false,
          });
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.indexBloc.inactiveChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState(
            {
              loading: false,
              success: true,
              loadingTable: true,
            },
            function () {
              this.setTokenAPI();
              //this.props.handleInactiveSuccess()
            }
          );
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.indexBloc.listChannel?.unsubscribe();
    this.indexBloc.inactiveChannel?.unsubscribe();
  }

  columns = [
    {
      key: "employee_transfer_date",
      text: "Period",
      sortable: true,
      cell: (record) => {
        return reformatDate(record.employee_transfer_date);
      },
    },
    {
      key: "list_pegawai_mutasi",
      text: "Daftar Pegawai & Jenis Mutasi",
      sortable: false,
      cell: (record) => {
        let pegawai = record.list_pegawai_mutasi;
        return (
          <ul
            style={{ margin: 0, paddingLeft: '20px', fontSize: '13px' }}
            dangerouslySetInnerHTML={{
              __html: pegawai,
            }}
          />
        );
      },
    },
    {
      key: "created_by_uuid",
      text: "Dibuat Oleh",
      sortable: true,
      cell: (record) => {
        return (
          <div>
            <span className="d-block font-size-12">{record.created_by_uuid || '-'}</span>
            <span className="text-muted font-size-11">{reformatDate(record.employee_transfer_create_date)}</span>
          </div>
        );
      },
    },
    {
      key: "updated_by_uuid",
      text: "Diubah Oleh",
      sortable: true,
      cell: (record) => {
        return (
          <div>
            <span className="d-block font-size-12">{record.updated_by_uuid || '-'}</span>
            <span className="text-muted font-size-11">{record.employee_transfer_log_date ? reformatDate(record.employee_transfer_log_date) : '-'}</span>
          </div>
        );
      },
    },
    {
      key: "employee_transfer_approval_status",
      text: "Status",
      sortable: true,
      cell: (record) => {
        if (record.employee_transfer_approval_status) {
          let status = parseInt(record.employee_transfer_approval_status);
          if (status == 1) {
            status = (
              <label className="badge rounded-pill bg-soft-success font-size-12">
                Selesai
              </label>
            );
          } else {
            status = (
              <label className="badge rounded-pill bg-soft-info font-size-12">
                Draft
              </label>
            );
          }
          return <span> {status} </span>;
        }
        return (
          <label className="badge rounded-pill bg-soft-info font-size-12">
            Draft
          </label>
        );
      },
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 120,
      sortable: false,
      align: "center",
      cell: (record) => {
        const thisId = record.employee_transfer_id;
        return (
          <Fragment>
            <span>
              <button
                className="btn btn-primary btn-sm"
                id={"detail-" + thisId}
                onClick={() => {
                  this.setState({
                    detailUuid: record.employee_transfer_uuid,
                  });
                }}
                style={{
                  marginRight: "2px",
                  padding: "2px 5px",
                }}
              >
                <i className="uil-align-left"></i>
              </button>
              <Tooltip
                style={{
                  marginBottom: 2,
                }}
                placement="top"
                isOpen={this.state["detail" + thisId]}
                target={"detail-" + thisId}
                toggle={() => {
                  this.setState({
                    ["detail" + thisId]: !this.state["detail" + thisId],
                  });
                }}
              >
                Detail
              </Tooltip>
            </span>
            {record.employee_transfer_approval_status !== 1 && (
              <Fragment>
                {accessRole("approve") && (
                  <span>
                    <button
                      className="btn btn-success btn-sm"
                      id={"update-" + thisId}
                      onClick={() => {
                        this.setState({
                          updateUuid: record.employee_transfer_uuid,
                        });
                      }}
                      style={{
                        marginRight: "2px",
                        padding: "2px 5px",
                      }}
                    >
                      <i className="uil-user-check"></i>
                    </button>
                    <Tooltip
                      style={{
                        marginBottom: 2,
                      }}
                      placement="top"
                      isOpen={this.state["update-" + thisId]}
                      target={"update-" + thisId}
                      toggle={() => {
                        this.setState({
                          ["update-" + thisId]: !this.state["update-" + thisId],
                        });
                      }}
                    >
                      Selesaikan Proses
                    </Tooltip>
                  </span>
                )}
                <span>
                  <button
                    className="btn btn-danger btn-sm"
                    id={"delete-" + thisId}
                    onClick={() => {
                      this.setState({
                        inactiveUuid: record.employee_transfer_uuid,
                        confirm: true,
                      });
                      this.modal_confirm_status = 1;
                    }}
                    style={{
                      marginRight: "2px",
                      padding: "2px 5px",
                    }}
                  >
                    <i className="uil-trash-alt"></i>
                  </button>
                  <Tooltip
                    style={{
                      marginBottom: 2,
                    }}
                    placement="top"
                    isOpen={this.state["delete-" + thisId]}
                    target={"delete-" + thisId}
                    toggle={() => {
                      this.setState({
                        ["delete-" + thisId]: !this.state["delete-" + thisId],
                      });
                    }}
                  >
                    Hapus
                  </Tooltip>
                </span>
              </Fragment>
            )}
          </Fragment>
        );
      },
    },
  ];

  render() {
    return (
      <Fragment>
        <MKIDatatable
          className={this.configDatatable.tableClass}
          config={this.configDatatable}
          records={this.state.rows}
          columns={this.columns}
          dynamic={true}
          minWidth={1000}
          total_record={this.state.totalRow}
          initial={this.state.filter}
          onChange={(filter) => {
            this.setState(
              {
                loadingTable: true,
                filter: filter,
              },
              function () {
                this.setTokenAPI();
              }
            );
          }}
          loading={this.state.loadingTable}
        />
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menghapus data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil dihapus"
          failedTitle="Gagal!"
          failedInfo="Data gagal dihapus"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.detailUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/mutasi_baru.html?updatemutasi=1&uuid=" +
              this.state.detailUuid
            }
          />
        ) : null}
        {this.state.updateUuid !== null ? (
          <Redirect
            to={
              "/kepegawaian/mutasi_baru.html?updatemutasi=1&uuid=" +
              this.state.updateUuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default TableComponent;
